
  (function () {
    var MODE = null;
    var REFILL_IMG = null;
    var REFILL_PRICE_CENTS = 2495;
    var MAIN_IMG = null;
    var BOX_IMGS = {};
    function oktLeesConfig() {
      var el = document.querySelector('script[data-okt-config]');
      if (!el) return false;
      try {
        var c = JSON.parse(el.textContent);
        MODE = c.mode || 'airpro';
        REFILL_IMG = c.refillImg || null;
        REFILL_PRICE_CENTS = c.refillPriceCents || 2495;
        MAIN_IMG = c.mainImg || null;
        BOX_IMGS = c.boxImgs || {};
        return true;
      } catch (e) { return false; }
    }
    var COLORS = ['black', 'contrast', 'cobalt', 'clear'];

    function currentColor() {
      var inputs = document.querySelectorAll('variant-picker input[type=radio]:checked');
      for (var i = 0; i < inputs.length; i++) {
        var v = (inputs[i].value || '').toLowerCase();
        if (COLORS.indexOf(v) > -1) return v;
      }
      return 'black';
    }

    function boxImg() {
      return BOX_IMGS[currentColor()] || MAIN_IMG;
    }

    function isBoth() {
      var both = false;
      document.querySelectorAll('variant-picker input[type=radio]:checked').forEach(function (i) {
        var v = (i.value || '').toLowerCase();
        if (v.indexOf('zowel') > -1 || v.indexOf('beide') > -1 || v.indexOf('2x') > -1) both = true;
      });
      return both;
    }

    function decorate() {
      document.querySelectorAll('variant-picker fieldset').forEach(function (f) {
        var leg = f.querySelector('legend');
        if (!leg || leg.textContent.toLowerCase().indexOf('gebruik') === -1) return;
        f.querySelectorAll('label.variant-option__button-label').forEach(function (lbl) {
          if (lbl.querySelector('.optimice-gebruik-extra')) return;
          var input = lbl.querySelector('input');
          var v = ((input && input.value) || '').toLowerCase();
          var both = v.indexOf('zowel') > -1 || v.indexOf('beide') > -1 || v.indexOf('2x') > -1;
          var packs = both ? 2 : 1;
          var text = both ? '2 refill packs per maand' : '1 refill pack per maand';
          var span = document.createElement('span');
          span.className = 'optimice-gebruik-extra';
          var imgs = '';
          for (var i = 0; i < packs; i++) {
            imgs += '<img src="' + REFILL_IMG + '" alt="" loading="lazy">';
          }
          span.innerHTML = '<span class="optimice-gebruik-extra__imgs">' + imgs + '</span><span>' + text + '</span>';
          lbl.appendChild(span);
        });
      });
    }

    function shortenTitles() {
      document.querySelectorAll('.subscription-selector__title').forEach(function (t) {
        var txt = t.textContent;
        var kort = txt.replace(/\s*bezorgd\s*$/i, '').replace(/^Eenmalige aankoop$/i, 'Eenmalig').replace(/^\s*1 maand\s*$/i, 'Elke maand').replace(/^\s*2 maanden\s*$/i, 'Elke 2 maanden');
        if (txt !== kort) t.textContent = kort;
      });
    }

    function structure() {
      var opts = document.querySelector('.subscription-selector__options');
      if (!opts) return;
      if (!opts.querySelector('.optimice-koop-header')) {
        var h = document.createElement('div');
        h.className = 'optimice-koop-header';
        h.textContent = 'Refill Plan - incl. 3 gratis cadeaus';
        opts.prepend(h);
      }
      var ot = opts.querySelector('input[id$="-one-time"]');
      if (ot) {
        var lbl = ot.closest('label');
        if (lbl && !lbl.classList.contains('optimice-koop-eenmalig')) {
          lbl.classList.add('optimice-koop-eenmalig');
        }
        if (lbl && !lbl.querySelector('.optimice-eenmalig-sub')) {
          var content = lbl.querySelector('.subscription-selector__content');
          if (content) {
            var s = document.createElement('span');
            s.className = 'optimice-eenmalig-sub';
            s.textContent = 'Alleen deze box · 60 tabs (goed voor 30 nachten of workouts)';
            content.appendChild(s);
          }
        }
      }
    }

    function fixBadges() {
      var perMomentLos = REFILL_PRICE_CENTS / 30;
      if (!perMomentLos) return;
      var both = isBoth();
      document.querySelectorAll('.subscription-selector__option').forEach(function (lbl) {
        var t = lbl.textContent;
        if (/eenmalig|one-time/i.test(t)) return;
        var monEl = lbl.querySelector('.subscription-selector__price--monthly');
        var rec = monEl ? parseInt(monEl.getAttribute('data-unit-price-cents'), 10) : 0;
        if (!rec) return;
        var is2m = /2\s*(maanden|months)/i.test(t);
        var moments = (is2m ? 60 : 30) * (both ? 2 : 1);
        var pct = Math.round((1 - (rec / moments) / perMomentLos) * 100);
        if (pct <= 0) return;
        var badges = lbl.querySelectorAll('.subscription-selector__badge');
        badges.forEach(function (b) {
          if (b.classList.contains('subscription-selector__badge--recommended')) return;
          var prefix = /save/i.test(b.textContent) ? 'Save ' : 'Bespaar ';
          var target = prefix + pct + '%';
          if (b.textContent.trim() !== target) b.textContent = target;
        });
      });
    }

    function imgsHtml(n, firstSrc, restSrc) {
      var h = '';
      for (var i = 0; i < n; i++) h += '<img src="' + (i === 0 ? firstSrc : restSrc) + '" alt="">';
      return '<span class="optimice-plan-detail__imgs">' + h + '</span>';
    }

    function groupHtml(label, imgs) {
      return '<span class="optimice-plan-detail__group"><span class="optimice-plan-detail__lbl">' + label + '</span>' + imgs + '</span>';
    }

    function fmtCents(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function prijsKolom(lbl, bedrag, sub) {
      return '<span class="optimice-prijsblok__col"><span class="optimice-prijsblok__lbl">' + lbl + '</span><span class="optimice-prijsblok__bedrag">' + bedrag + '</span><span class="optimice-prijsblok__sub">' + sub + '</span></span>';
    }

    function prijsblok() {
      var sel = document.querySelector('.subscription-selector');
      var pp = document.querySelector('.product-information .product-details product-price');
      if (!sel || !pp) return;
      document.querySelectorAll('.product-information .product-details p, .product-information .product-details small, .product-information .product-details span, .product-information .product-details div').forEach(function (el) {
        if (el.__optVerborgen) return;
        if (el.children.length !== 0) return;
        if (!/Verzendkosten worden berekend/.test(el.textContent)) return;
        var doel = el.closest('p, small') || el;
        if ((doel.textContent || '').length > 140) doel = el;
        doel.__optVerborgen = true;
        doel.style.display = 'none';
      });
      var blok = document.querySelector('.optimice-prijsblok');
      if (!blok) {
        blok = document.createElement('div');
        blok.className = 'optimice-prijsblok';
        pp.parentElement.insertBefore(blok, pp);
      }
      var checked = sel.querySelector('.subscription-selector__input:checked');
      if (!checked) return;
      var oneTime = /-one-time$/.test(checked.id);
      var otInput = sel.querySelector('input[id$="-one-time"]');
      var otCents = otInput ? parseInt(otInput.getAttribute('data-price-cents'), 10) : 0;
      var html = '';
      if (oneTime) {
        html = '<span class="optimice-prijsblok__col optimice-prijsblok__col--vol"><span class="optimice-prijsblok__lbl">Eenmalig</span><span class="optimice-prijsblok__bedrag">' + fmtCents(otCents) + '</span><span class="optimice-prijsblok__sub">AirPro incl. 60 tabs, goed voor 30 nachten of workouts \u00b7 geen vervolg</span></span>';
      } else {
        var lbl0 = checked.closest('label');
        var monEl = lbl0 ? lbl0.querySelector('.subscription-selector__price--monthly') : null;
        var recCents = monEl ? parseInt(monEl.getAttribute('data-unit-price-cents'), 10) : 0;
        if (!recCents) recCents = parseInt(checked.getAttribute('data-price-cents'), 10) || 0;
        var lblTxt = (lbl0 || {}).textContent || '';
        var is2m = /2\s*maanden/i.test(lblTxt);
        var both = isBoth();
        var packs = (is2m ? 2 : 1) * (both ? 2 : 1);
        // Eerste betaling: data-price-cents op de gekozen plan-radio is de betrouwbare bron
        // (Horizons eigen "Eerste betaling"-tekst loopt achter bij planwissels).
        var fpCents = parseInt(checked.getAttribute('data-price-cents'), 10) || 0;
        if (!fpCents) {
          var fpEl = document.querySelector('.product-price__price--first-payment');
          var fpMatch = fpEl ? fpEl.textContent.match(/([0-9]+[.,][0-9]{2})/) : null;
          fpCents = fpMatch ? Math.round(parseFloat(fpMatch[1].replace(',', '.')) * 100) : otCents;
        }
        var moments = (is2m ? 60 : 30) * (both ? 2 : 1);
        var firstExtra = Math.max(0, Math.round((moments - 30) / 30));
        var vandaagSub = 'AirPro incl. 60 tabs, goed voor 30 nachten of workouts';
        if (firstExtra > 0) vandaagSub += ' + ' + firstExtra + ' refill pack' + (firstExtra > 1 ? 's' : '');
        html = prijsKolom('Vandaag', fmtCents(fpCents), vandaagSub)
          + '<span class="optimice-prijsblok__sep"></span>'
          + prijsKolom(is2m ? 'Daarna per 2 maanden' : 'Daarna per maand', fmtCents(recCents), packs + ' refill pack' + (packs > 1 ? 's' : '') + ' automatisch thuis');
      }
      html += '<span class="optimice-prijsblok__noot">Incl. btw \u00b7 Gratis verzending in NL & BE</span>';
      if (!oneTime) {
        html += '<span class="optimice-prijsblok__noot optimice-prijsblok__noot--account">Elk moment stopzetten of je refill packs aanpassen in je eigen Optimice-account.</span>';
      }
      if (blok.__last !== html) {
        blok.__last = html;
        blok.innerHTML = html;
      }
    }

    function planDetail() {
      var sel = document.querySelector('.subscription-selector');
      if (!sel) return;
      var opts = sel.querySelector('.subscription-selector__options');
      if (!opts) return;
      var detail = sel.querySelector('.optimice-plan-detail');
      if (!detail) {
        detail = document.createElement('div');
        detail.className = 'optimice-plan-detail';
        opts.insertAdjacentElement('afterend', detail);
      }
      var checked = sel.querySelector('.subscription-selector__input:checked');
      if (!checked) { if (!detail.hidden) detail.hidden = true; return; }
      var lbl = checked.closest('label');
      var t = (lbl && lbl.textContent) || '';
      var both = isBoth();
      var is2m = /2\s*maanden/i.test(t);
      var oneTime = /eenmalig/i.test(t);
      var moments = (is2m ? 60 : 30) * (both ? 2 : 1);
      var perCents = 0;
      if (!oneTime) {
        var monEl = lbl ? lbl.querySelector('.subscription-selector__price--monthly') : null;
        var recCents = monEl ? parseInt(monEl.getAttribute('data-unit-price-cents'), 10) : 0;
        if (recCents > 0) perCents = Math.round(recCents / moments);
      }
      var html = '';
      if (oneTime) {
        html = groupHtml('Je ontvangt', imgsHtml(1, boxImg(), REFILL_IMG));
      } else {
        var firstExtra = Math.max(0, Math.round((moments - 30) / 30));
        var recurPacks = Math.round(moments / 30);
        html = groupHtml('Nu', imgsHtml(1 + firstExtra, boxImg(), REFILL_IMG))
          + groupHtml(is2m ? 'Daarna per 2 mnd' : 'Daarna per mnd', imgsHtml(recurPacks, REFILL_IMG, REFILL_IMG));
      }
      if (perCents > 0 && !oneTime) {
        html += '<span class="optimice-plan-detail__price"><strong>' + fmtCents(perCents) + '</strong><span>per nacht/workout</span></span>';
      }
      if (detail.__last !== html) {
        detail.__last = html;
        detail.innerHTML = html;
      }
      if (detail.hidden) detail.hidden = false;
    }

    function updateSuffix() {
      var checked = document.querySelector('.subscription-selector__input:checked');
      if (!checked) return;
      var lbl = checked.closest('label');
      if (!lbl) return;
      var two = /2 *\s*maanden|2 *\s*months/i.test(lbl.textContent);
      document.querySelectorAll('.product-price__suffix').forEach(function (s) {
        var en = /month/i.test(s.textContent) && !/maand/i.test(s.textContent);
        var target = two ? (en ? 'per 2 months' : 'per 2 maanden') : (en ? 'per month' : 'per maand');
        if (s.textContent !== target) s.textContent = target;
      });
    }


    function vertaalJuo() {
      var map = { 'Delivery every month': 'Elke maand', 'Delivery every 2 months': 'Elke 2 maanden', 'Delivery every week': 'Elke week' };
      document.querySelectorAll('.juo-reset select[data-ref="selling-plan"] option').forEach(function (o) {
        var t = o.textContent.trim();
        if (map[t]) o.textContent = map[t];
      });
      var planNaam = document.querySelector('.juo-reset .j-subscription .j-label-inner > span:last-child');
      if (planNaam && planNaam.textContent.trim() === 'Refill Plan' && /mondtape/i.test(document.title)) {
        planNaam.textContent = 'Mondtape Refill Plan';
      }
    }
    function zetAantal(n) {
      var q = document.querySelector('.product-information input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
      if (!q) return;
      if (parseInt(q.value, 10) === n) return;
      q.value = n;
      q.dispatchEvent(new Event('input', { bubbles: true }));
      q.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function ritmeKnoppen() {
      var sub = document.querySelector('.juo-reset .j-subscription');
      if (!sub) return;
      var sel = sub.querySelector('select[data-ref="selling-plan"]');
      if (!sel || sel.options.length < 2) return;
      var basis = 0, prijzen = {};
      var dataEl = document.getElementById('juo-subscription-widget-data');
      if (dataEl) {
        try {
          var jd = JSON.parse(dataEl.textContent);
          var v = (jd[0] && jd[0][0]) ? jd[0][0] : null;
          if (v) { basis = v.price || 0; (v.sellingPlans || []).forEach(function (p) { prijzen[String(p.id)] = p.price; }); }
        } catch (e) {}
      }
      var sw = sub.querySelector('.j-select-wrapper');
      var wrap = sub.querySelector('.optimice-ritme');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'optimice-ritme';
        if (sw) sw.insertAdjacentElement('beforebegin', wrap);
        else return;
      }
      if (sw) sw.style.display = 'none';
      var html = '';
      Array.prototype.forEach.call(sel.options, function (o) {
        var cents = prijzen[o.value];
        var is2 = /2/.test(o.textContent);
        var mult = is2 ? 2 : 1;
        var pct = (cents && basis) ? Math.round((1 - cents / basis) * 100) : 0;
        html += '<button type="button" class="optimice-ritme__opt' + (sel.value === o.value ? ' is-actief' : '') + '" data-waarde="' + o.value + '" data-mult="' + mult + '">'
          + (is2 ? '<span class="optimice-ritme__ab">Aanbevolen</span>' : '')
          + '<span class="optimice-ritme__naam">' + o.textContent.trim() + '</span>'
          + (cents ? '<span class="optimice-ritme__prijs">\u20ac' + (cents * mult / 100).toFixed(2).replace('.', ',') + '</span><span class="optimice-ritme__sub">' + (mult > 1 ? '2 stuks per levering' : 'per levering') + '</span>' : '')
          + (pct > 0 ? '<span class="optimice-ritme__badge">Bespaar ' + pct + '%</span>' : '')
          + '</button>';
      });
      if (wrap.__last !== html) {
        wrap.__last = html;
        wrap.innerHTML = html;
        wrap.querySelectorAll('button').forEach(function (kn) {
          kn.addEventListener('click', function () {
            sel.value = kn.getAttribute('data-waarde');
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            zetAantal(parseInt(kn.getAttribute('data-mult'), 10) || 1);
            setTimeout(run, 60);
            setTimeout(run, 400);
          });
        });
      }
      if (!document.__optimiceRitmeInit) {
        document.__optimiceRitmeInit = true;
        var twee = Array.prototype.filter.call(sel.options, function (o) { return /2/.test(o.textContent); })[0];
        if (twee && sel.value !== twee.value) {
          sel.value = twee.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(run, 60);
          setTimeout(run, 400);
        }
        if (twee && sel.value === twee.value) zetAantal(2);
        if (!document.__optimiceAantalSync) {
          document.__optimiceAantalSync = true;
          document.addEventListener('change', function (e) {
            var t = e.target;
            if (!t || !t.closest || !t.closest('.juo-reset') || t.type !== 'radio') return;
            var aboActief = !!document.querySelector('.juo-reset .j-subscription input:checked');
            if (!aboActief) { zetAantal(1); return; }
            var s = document.querySelector('.juo-reset select[data-ref="selling-plan"]');
            var opt = s && s.selectedOptions && s.selectedOptions[0];
            zetAantal(opt && /2/.test(opt.textContent) ? 2 : 1);
          });
        }
      }
    }

    function juoPrijzen() {
      var basis = 0, prijzen = {};
      var dataEl = document.getElementById('juo-subscription-widget-data');
      if (dataEl) {
        try {
          var jd = JSON.parse(dataEl.textContent);
          var v = (jd[0] && jd[0][0]) ? jd[0][0] : null;
          if (v) { basis = v.price || 0; (v.sellingPlans || []).forEach(function (p) { prijzen[String(p.id)] = p.price; }); }
        } catch (e) {}
      }
      return { basis: basis, prijzen: prijzen };
    }
    function fmtC(cents) { return '\u20ac' + (cents / 100).toFixed(2).replace('.', ','); }
    function prijsblokSimpel() {
      var juo = document.querySelector('.juo-reset');
      var pp = document.querySelector('.product-information .product-details product-price');
      if (!juo || !pp) return;
      pp.style.display = 'none';
      var blok = document.querySelector('.optimice-prijsblok-lite');
      if (!blok) {
        blok = document.createElement('div');
        blok.className = 'optimice-prijsblok-lite';
        pp.insertAdjacentElement('beforebegin', blok);
      }
      var pd = juoPrijzen();
      var aboChecked = !!juo.querySelector('.j-subscription input:checked');
      var html = '';
      if (aboChecked) {
        var sel = juo.querySelector('select[data-ref="selling-plan"]');
        var cents = sel ? (pd.prijzen[sel.value] || 0) : 0;
        var optTxt = (sel && sel.selectedIndex >= 0) ? sel.options[sel.selectedIndex].textContent.trim().toLowerCase() : '';
        if (!cents) return;
        var mult = /2/.test(optTxt) ? 2 : 1;
        html = '<span class="optimice-prijsblok-lite__lbl">Per levering</span>'
          + '<span class="optimice-prijsblok-lite__rij"><span class="optimice-prijsblok-lite__bedrag">' + fmtC(cents * mult) + '</span>'
          + (pd.basis > cents ? '<span class="optimice-prijsblok-lite__oud">' + fmtC(pd.basis * mult) + '</span>' : '')
          + '</span>'
          + '<span class="optimice-prijsblok-lite__sub">' + (mult > 1 ? '2 stuks, ' : '') + optTxt + ' automatisch thuisbezorgd</span>';
      } else {
        if (!pd.basis) return;
        html = '<span class="optimice-prijsblok-lite__lbl">Eenmalig</span>'
          + '<span class="optimice-prijsblok-lite__rij"><span class="optimice-prijsblok-lite__bedrag">' + fmtC(pd.basis) + '</span></span>'
          + '<span class="optimice-prijsblok-lite__sub">alleen deze bestelling, geen vervolg</span>';
      }
      if (blok.__last !== html) {
        blok.__last = html;
        blok.innerHTML = html;
      }
    }

    function verzendNoot() {
      var pp = document.querySelector('.product-information .product-details product-price');
      if (!pp || document.querySelector('.optimice-verzendnoot')) return;
      var n = document.createElement('div');
      n.className = 'optimice-verzendnoot';
      var abo = document.querySelector('.juo-reset');
      n.innerHTML = 'Incl. btw \u00b7 Gratis verzending in NL & BE' + (abo ? '<span class="acc">Abonnement elk moment stopzetten of aanpassen in je eigen Optimice-account.</span>' : '');
      pp.insertAdjacentElement('afterend', n);
    }

    var __cartPlanDruk = false;
    function planNaarNL(naam) {
      if (/delivery every 2 month/i.test(naam)) return 'Refill Plan \u00b7 elke 2 maanden';
      if (/delivery every month/i.test(naam)) return 'Refill Plan \u00b7 elke maand';
      var m = naam.match(/delivery every (\d+) month/i);
      if (m) return 'Refill Plan \u00b7 elke ' + m[1] + ' maanden';
      return naam;
    }
    function cartPlanLabels() {
      // 1) Drawer: Engelse planregel vertalen en als pill stylen
      document.querySelectorAll('.cart-items__details').forEach(function (details) {
        [].forEach.call(details.querySelectorAll('*'), function (e) {
          if (e.children.length !== 0) return;
          if (!/delivery every/i.test(e.textContent)) return;
          e.textContent = planNaarNL(e.textContent.trim());
          if (!e.classList.contains('optimice-cart-plan')) {
            e.classList.add('optimice-cart-plan');
            e.style.cssText = 'display:inline-block;background:#343bf5;color:#fff;font-size:11px;font-weight:700;padding:2px 9px;border-radius:999px;margin-top:4px;line-height:1.5;';
          }
        });
      });
      // 2) Cart-pagina: infopil onder de tabel met de actieve plannen
      var tafel = document.querySelector('.cart-page__table');
      if (!tafel || __cartPlanDruk) return;
      __cartPlanDruk = true;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var subs = cart.items.filter(function (i) { return i.selling_plan_allocation && i.selling_plan_allocation.selling_plan; });
        var hash = cart.item_count + ':' + cart.total_price + ':' + subs.length;
        var div = document.querySelector('.optimice-cart-plan-info');
        if (!subs.length) { if (div) div.remove(); return; }
        if (div && div.getAttribute('data-hash') === hash) return;
        if (!div) {
          div = document.createElement('div');
          div.className = 'optimice-cart-plan-info';
          div.style.cssText = 'margin:2px 0 18px;display:flex;flex-wrap:wrap;gap:8px;';
          tafel.insertAdjacentElement('afterend', div);
        }
        div.setAttribute('data-hash', hash);
        div.innerHTML = subs.map(function (i) {
          var naam = planNaarNL(i.selling_plan_allocation.selling_plan.name);
          var stuks = i.quantity > 1 ? ' \u00b7 ' + i.quantity + ' stuks per levering' : '';
          return '<span style="display:inline-block;background:#343bf5;color:#fff;font-size:12px;font-weight:700;padding:5px 14px;border-radius:999px;line-height:1.5;">\u2713 ' + naam + ' actief' + stuks + '</span>';
        }).join('');
      }).catch(function () {}).then(function () { __cartPlanDruk = false; });
    }

    function run() {
      cartPlanLabels();
      if (!oktLeesConfig()) return;
      if (MODE === 'airpro') {
        decorate();
        shortenTitles();
        structure();
        fixBadges();
        planDetail();
        prijsblok();
      }
      if (MODE === 'simpel') {
        vertaalJuo();
        ritmeKnoppen();
        prijsblokSimpel();
        verzendNoot();
        var stepper = document.querySelector('.product-information quantity-selector-component, quantity-selector-component.quantity-selector');
        if (stepper) {
          var aboAan = !!document.querySelector('.juo-reset .j-subscription input:checked');
          stepper.style.display = aboAan ? 'none' : '';
          if (aboAan) {
            var sPlan = document.querySelector('.juo-reset select[data-ref="selling-plan"]');
            var sOpt = sPlan && sPlan.selectedOptions && sPlan.selectedOptions[0];
            zetAantal(sOpt && /2/.test(sOpt.textContent) ? 2 : 1);
          }
        }
        var accEl = document.querySelector('.optimice-verzendnoot .acc');
        if (accEl) {
          var aboActief = !!document.querySelector('.juo-reset .j-subscription input:checked');
          accEl.style.display = aboActief ? '' : 'none';
        }
      }
      updateSuffix();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('change', function (e) {
      if (!e.target) return;
      var inSelector = e.target.classList && e.target.classList.contains('subscription-selector__input');
      var inPicker = e.target.closest && e.target.closest('variant-picker');
      var inJuo = e.target.closest && e.target.closest('.juo-reset');
      if (inSelector || inPicker || inJuo) {
        setTimeout(run, 60);
        setTimeout(run, 400);
      }
    });
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(run, 150);
    }).observe(document.body, { childList: true, subtree: true });
  })();
